import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';
import {rgba} from 'polished';

const StyledPatentBarChart = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${props => props.theme.layout('3sp')};
  height: 100%;
  overflow: hidden;
  
  // see graph margins
  margin-left: ${props => props.theme.layout(-32)};
  width: calc(100% + ${props => props.theme.layout(32)});

  .PatentBarChart {
    &-chart {
      height: 100%;
      width: 100%;
      overflow: hidden;

      .recharts-cartesian {
        &-axis {
          &-tick-value {
            fill: ${props => utils.rgba2Rgb(props.theme.property('palette.text.disabled'))};
          }

          &-line {
            stroke: transparent;
          }
        }
        
        &-grid {
          .recharts-cartesian-grid-horizontal {
            line:first-child {
              stroke: transparent;
            }
          }
        }
      }
    }

    &-limit {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: ${props => rgba(props.theme.property('palette.text.primary'), props.theme.property('palette.action.disabledOpacity'))};
      font-style: italic;
      position: absolute;
      
      .P {
        white-space: pre-line;
        margin: -${props => props.theme.spacing(2)} 0 ${props => props.theme.spacing(1)} 0;
      }
    }
    
    &-legend {
      flex-grow: 1;
      align-items: center;
    }
  }
  
  ${ComponentStyles}
`;

StyledPatentBarChart.propTypes = {
};

export default StyledPatentBarChart;
